import { useCallback, useState } from "react";
import { TimekeeperService } from "services/TimekeeperService";
import { Paycode } from "repository/timekeeper/@types/PaycodeModel";

const timekeeperService = new TimekeeperService();

export const usePaycodesQuery = () => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<Paycode[]>([]);

    const loadData = useCallback(async () => {
        setLoading(true);

        try {
            const data = await timekeeperService.paycodes.getPaycodes();
            setRows(data as Paycode[]);
        } catch (error) {
            console.error("Error loading paycodes:", error);
            setRows([]);
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        rows,
        setRows,
        loading,
        setLoading,
        loadData,
    };
};
